import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Results from "./sections/Results";
import Casestudies from "./sections/Casestudies";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Casestudies />
      <Results />
      <Footer />
    </div>;
}